import React from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export default function HomeAbout() {
    return (
        <Container fluid className='mt-5 mb-5 home_about_container'>
            {/* <img className="homeabout-image" src="/images/pages/home/about.jpg" alt="Loading.." /> */}
            <Container>
                <div className="row home_about_row">
                    <div className='home_row_line' ></div>
                    <div className=" col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 homeabout-col">
                        <h3 className='homeabout-title'> Dr. BHUPATHI RAJENDRA PRASAD </h3>
                        <p>Sr. Consultant – Surgical Gastroenterology, GI & HPB Onco Surgery, General & Laparoscopic Surgery</p>
                        <p> Dr. Bhupathi Rajendra Prasad completed MBBS from KMC, Warangal, Telangana, MS (General Surgery) from Osmania & Superspeciality from NIMS, Hyd. Others include IHPBA certificate course, FMAS skill course. He is well trained in Laparoscopic surgery at excellent centers.  </p> <div />
                        <p> He has given several lectures, chaired sessions, presented papers & posters at various conferences. He is an accomplished member of various societies which includes ASI, AMASI, IMA and IASG.  </p>
                        <p> Dr. Bhupathi Rajendra Prasad has vast experience in surgical field & has successfully performed more than 5000 Surgeries (Major & complex surgeries of GIT including Liver, Gall bladder, Biliary tract, Pancreas, Spleen, Abdominal wall & retroperitoneum). His special interests include complex GI/HPB & Laparoscopic surgery, Patient Centric care, teaching & training students.</p>
                        {/* <Link to="/about" className="about-link" >Know More</Link> */}
                    </div>
                </div>
            </Container>
        </Container>
    )
}
